import { css } from '@microsoft/fast-element';
import SolarImage from '../../../../assets/solar.png';

export const SellerTileStyles = css`
  .card-styles {
    width: 100%;
    display: flex;
    gap: 16px;
    padding: 6px 0;
  }

  .tile-info-div {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .tile-title-div {
    display: flex;
    gap: 16px;
    align-items: baseline;
  }

  .tile-all-projects-title-div {
    align-items: left;
  }

  .tile-elements-div {
    display: flex;
    gap: 16px;
  }

  .tile-elements-div .col {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .tile-elements-div .row {
    display: flex;
    gap: 16px;
    flex: 1 1 auto;
  }

  .tile-elements-div .col tile-card {
    flex: 1 1 auto;
  }

  .tile-elements-div zero-slider {
    width: 100%;
      cursor: pointer;
  }

  .tile-title {
    color: var(--primary-color);
    text-align: left;
    font-size: 22px;
  }

  .tile-title:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  .tile-all-projects-title {
    color: var(--white-smoke);
    padding: 16px 4px;
    text-align: left;
    font-size: 22px;
    font-family: 'Roboto-Bold', 'Roboto Bold', 'Roboto', sans-serif;
    font-weight: 700;
    line-height: 28px;
  }

  .tile-sub-title {
    color: #ccc;
    text-align: left;
    font-size: 12px;
  }

  .buttons-slot {
    position: absolute;
    right: 13px;
    top: 0;
  }
`;
